<script lang="ts" setup>
  import { IconUserCircle } from '@tabler/icons-vue';
  import Button from 'primevue/button';
  import { useAuthStore } from '@/stores/auth';
  import { useUserStore } from '@/stores/user';

  const router = useRouter();
  const userStore = useUserStore();
  const authStore = useAuthStore();
  const menu = ref();

  const { t } = useI18n({
    messages: {
      ru: {
        security: 'Безопасность',
        logout: 'Выйти',
      },
      en: {
        security: 'Security',
        logout: 'Log out',
      },
    },
  });

  const toggle = (event: Event) => {
    menu.value.toggle(event);
  };

  const logout = () => {
    authStore.logout();
    router.push({ name: 'login' });
  };

  const items = computed(() => [
    {
      label: t('security'),
      url: '/security',
      anchor: 'user.security',
    },
    {
      label: t('logout'),
      command: logout,
      anchor: 'user.logout',
    },
  ]);
</script>

<template>
  <Button
    v-if="userStore.user"
    class="overflow-hidden"
    type="button"
    severity="secondary"
    aria-haspopup="true"
    aria-controls="overlay_menu"
    @click="toggle">
    <span class="truncate" data-testid="username">{{
      userStore.user?.username
    }}</span>
    <IconUserCircle class="min-w-24" />
  </Button>
  <Skeleton v-else width="300px" class="overflow-hidden" height="10em" />
  <Menu id="overlay_menu" ref="menu" :model="items" :popup="true">
    <template #item="{ item, props }">
      <router-link
        v-if="item.url"
        v-slot="{ href, navigate }"
        :to="item.url"
        custom>
        <a
          class="flex items-center gap-8"
          :href="href"
          v-bind="props.action"
          @click="navigate">
          {{ item.label }}
          <VFeatureBadge v-if="item.anchor" :anchor="item.anchor" />
        </a>
      </router-link>
      <a
        v-else
        class="flex items-center gap-8"
        :href="item.url"
        :target="item.target"
        v-bind="props.action">
        {{ item.label }}
        <VFeatureBadge v-if="item.anchor" :anchor="item.anchor" />
      </a>
    </template>
  </Menu>
</template>
